(function() {
    var PrintRegistersButton =  function ($el) {
        this.$el = $el
        this.route = this.$el.data('register-endpoint')

        this.$el.on('click', this.openPrintPreview.bind(this))

        return this
    }

    PrintRegistersButton.prototype.openPrintPreview = function (event) {
        event.preventDefault()

        var ids = $('.generate-register:checked').map(function () {
            return $(this).data("class-id")
        })
        .get()
        .join(',')

        if (ids == '') {
            alert('No Registers Selected')

            return false;
        }

        window.open(this.route + '?ids=' + ids, '_blank')
    }

    $('.multi-register-button').each(function () {
        new PrintRegistersButton($(this))
    })
})()
